// export const backendUri = `http://localhost:5010`;
// export const redirectUri = `https://localhost:3001/react/?openid-callback`;
// export const postLogoutRedirectUri = `https://localhost:3001/logout-callback`;
// export const authCallbackPath = 'https://localhost:3001/react/?openid-callback';

/* console.log(process.env.REACT_APP_BACKEND_URI);
console.log(process.env.REACT_APP_BASE_URL_SLP); */

export const backendUri = process.env.REACT_APP_BACKEND_URI;
export const redirectUri = process.env.REACT_APP_REDIRECT_URI;
export const postLogoutRedirectUri = process.env.REACT_APP_POSTLOGOUT_URL;
export const authCallbackPath = process.env.REACT_APP_AUTH_CALLBACK_PATH;

export const scopes = "offline_access";
export const clientId = "web_client";
